module.exports = __webpack_public_path__ + "media/src/images/partners/luiss-f6b9797e7fb2daac949325c4eb756f93.jpg";